
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import Layout from "../components/Layout";
import HeroLanding from "../components/landings/HeroLanding";
import { useIsMobile } from "../lib/media";
import Headline from "../components/common/Headline";
import TextWithImg from "../components/TextWithImg";
import { StepDetail } from "../components/landings/StepsGroupDetail";
import { pushRoute } from "../lib/routing";
interface Props {
    deviceType?: string;
}
function HowItWorksLanding({ deviceType }: Props) {
    const { t } = useTranslation("howitworks");
    const isMobileViewport = useIsMobile(deviceType);
    // Images
    const getImg = (type: string) => {
        return `/images/landings/benefits_${type}.webp`;
    };
    // Info
    const icons: Record<string, string[]> = {
        area: ["verified", "star-off"],
        constact: [],
        booking: ["cancellation", "secure"],
        relax: ["vet", "support"]
    };
    // Action
    const onButtonClick = () => {
        pushRoute({ pathname: "/search" });
    };
    // Rendering
    const render = (type: string, color: string = "samoyedWhite", iconColor: string = "samoyedWhite") => {
        return (<>
        <Text color={color}>{t(`${type}Desc`)}</Text>
        {icons[type] &&
                [...Array(icons[type].length)].map((_, key) => (<StepDetail key={key} icon={{ text: icons[type][key], color: iconColor }} title={{ text: t(`${type}StepTitle${key + 1}`), color: color }} desc={{ text: t(`${type}StepDesc${key + 1}`), color: color }} variant="Benefits"/>))}
      </>);
    };
    return (<Layout withTransparentHeader title={t("pageName")} displayFooterAreas withHrefLang>
      <HeroLanding isMobileViewport={isMobileViewport} imgsrc={getImg("header")} title={t("title")} button={{ text: t("common:start"), onSubmit: onButtonClick }} width={{
            mobile: "100%",
            nonMobile: ["80%", "80%", "80%", "60%", "50%"]
        }} height={["400px", "400px", "480px"]}/>

      <Headline variant="veterinarycover" title={t("titleDesc")}/>

      <TextWithImg title={t("areaTitle")} imgsrc={getImg("area")} imgRight>
        {render("area")}
      </TextWithImg>

      <TextWithImg title={t("contactTitle")} imgsrc={getImg("contact")} imgRight={isMobileViewport} bgColor="samoyedWhite" color="labradorBlack">
        {render("contact", "labradorBlack", "inuOrange")}
      </TextWithImg>

      <TextWithImg title={t("bookingTitle")} imgsrc={getImg("booking")} imgRight>
        {render("booking")}
      </TextWithImg>

      <TextWithImg title={t("relaxTitle")} imgsrc={getImg("relax")} imgRight={isMobileViewport} bgColor="samoyedWhite" color="labradorBlack">
        {render("relax", "labradorBlack", "inuOrange")}
      </TextWithImg>
    </Layout>);
}
// For some unknown reason this page is being statically generated with development config.
// Forcing it to render on the server seems to solve the issue.
// We have only found this problem here but it may be happening in other places too. Keep an eye.
const getServerSideProps = () => ({
    props: {}
});
export default HowItWorksLanding;

    async function __Next_Translate__getServerSideProps__196cfbd51e6__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/howitworks',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__196cfbd51e6__ as getServerSideProps }
  